
export class Product {
  Id?: number = 0;
  Name: string = "";
  Link: string = "";
  Quantity: number = 1;
  UnitNetPrice: number = 0;
  UnitGrossPrice: number = 0;
  Tax: number = 0;
  UnitTaxValue: number = 0;
  CategoryLevel1: string = "";
  CategoryLevel2: string = "";
  CategoryLevel3: string = "";
  CanBuy: boolean = false;
  HasVariations: boolean = false;

  static fromJson(json: Partial<Product>, quantity = 1): Product {
    const product = new Product();
    product.Name = String(json?.Name || "");
    product.Link = String(json?.Link || "");
    product.Quantity = Number(quantity) || 1;
    product.UnitNetPrice = Number(json?.UnitNetPrice || 0);
    product.UnitGrossPrice = Number(json?.UnitGrossPrice || 0);
    product.Tax = Number(json?.Tax || 0);
    product.UnitTaxValue = Number(json?.UnitTaxValue || 0);
    product.CategoryLevel1 = String(json?.CategoryLevel1 || "");
    product.CategoryLevel2 = String(json?.CategoryLevel2 || "");
    product.CategoryLevel3 = String(json?.CategoryLevel3 || "");
    product.Id = Number(json?.Id || 0) || undefined;
    product.CanBuy = Boolean(json?.CanBuy || false);
    product.HasVariations = Boolean(json?.HasVariations || false);

    return product;
  }

  static toRequestBody(product: Product): any {
    return {
      Name: product.Name,
      Quantity: product.Quantity,
      UnitNetPrice: product.UnitNetPrice,
      UnitGrossPrice: product.UnitGrossPrice,
      Tax: product.Tax,
      UnitTaxValue: product.UnitTaxValue,
      CategoryLevel1: product.CategoryLevel1,
      CategoryLevel2: product.CategoryLevel2,
      CategoryLevel3: product.CategoryLevel3,
    };
  }
}
